export default {
  steps: {
    0: {
      title: 'Werde Stammgast',
      description: 'Sieh dir deinen Bestellverlauf an und bestell mit einem Tipp ganz einfach nochmal.',
    },
    1: {
      title: 'Hol dir Prämien',
      description: 'Behalte deinen Punktestand im Blick und löse gespeicherte Rewards direkt aus deinem Wallet ein.',
    },
    2: {
      title: 'Bestell vor',
      description: 'Finde den Standort in deiner Nähe – und gib deine Bestellung schneller auf als je zuvor.',
    },
  },
  buttons: {
    skip: 'Skip',
  },
};
